import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Drawer, Checkbox, Button } from '@mui/material';
import { getPointName as gpn } from '../../redux/selectors/points';
import { chunkArray } from '../../utils/collections';

import './series-picker.css';

const mapStateToProps = (state) => ({
  getPointName: (pointId) => {
    const name = gpn(state, pointId) || '';
    return name;
  },
  pointsById: state.entities.points.byId,
});

const COLUMNS = 5;

const drawerHeight = () => `${window.innerHeight * 0.8}px`;

/**
 * A controlled component for choosing which point ids from a series to display
 */
class SeriesPicker extends React.PureComponent {
  state = {
    open: false,
  };

  select = (id, checked) => {
    const { onChange, selectedPointIds } = this.props;
    const newSelection = checked
      ? [id, ...selectedPointIds]
      : selectedPointIds.filter((pid) => id !== pid);
    onChange(newSelection);
  };

  renderPointSubtitle = (pointId) => {
    const subtitle = this.props.pointsById[pointId]?.name || '';
    return (
      <>
        <br />
        <span className="subtitle">{subtitle}</span>
      </>
    );
  };

  renderColumn = (col, selected) =>
    col.map(({ id, label }) => (
      <div key={id}>
        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
        <label>
          {label}
          <Checkbox
            checked={selected.has(id)}
            onChange={({ target: { checked } }) => this.select(id, checked)}
          />
          {this.renderPointSubtitle(id)}
        </label>
      </div>
    ));

  render() {
    const { pointIds, selectedPointIds, getPointName } = this.props;
    const selectedSet = new Set(selectedPointIds);
    const withLabels = pointIds.map((id) => ({ id, label: getPointName(id) }));
    const perColumn = Math.ceil(pointIds.length / COLUMNS);
    const columns = chunkArray(withLabels, perColumn);
    return (
      <>
        <span className="trend-picker-button">
          <Button variant="outlined" onClick={() => this.setState({ open: true })}>
            {selectedPointIds.length} of {pointIds.length} selected
          </Button>
        </span>
        <Drawer
          open={this.state.open}
          onClose={() => this.setState({ open: false })}
          anchor="bottom"
        >
          <div
            className="trend-series-picker"
            role="presentation"
            style={{ maxHeight: drawerHeight() }}
          >
            {columns.map((col) => (
              <div key={col[0].id} className="series-col">
                {this.renderColumn(col, selectedSet)}
              </div>
            ))}
          </div>
        </Drawer>
      </>
    );
  }
}

SeriesPicker.propTypes = {
  pointIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  selectedPointIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default connect(mapStateToProps)(SeriesPicker);
